import styled from '@emotion/styled';

export const MdxLinkStyled = styled.section`
    color: ${({ theme }) => theme.colors.yellow3};
`;

export const MdxLink: React.FC<{ html: string; link: string }> = props => {
    const { html, link } = props;

    return (
        <a
            target="\_blank"
            rel="noopener noreferrer"
            href={`${link}`}
            dangerouslySetInnerHTML={{ __html: `${html}` }}
        ></a>
    );
};
